import "./reviewList.scss";
import {ReviewListController} from "@/scripts/components/review-list/reviewListController";
import {NAMES} from "@/scripts/components/review-list/constants/reviewList.constants";

export function defineReviewListElement() {
  const TAG_NAME = NAMES.TAG_NAME;

  if (customElements.get(TAG_NAME)) return;

  class AbReviewsListElement extends HTMLElement {

    #ctrl?: ReviewListController;

    get productId() { return this.getAttribute("product-id") ?? ""; }
    set productId(v: string) { this.setAttribute("product-id", v); }

    get productIdWp() { return this.getAttribute("wp-product-id") ?? ""; }
    set productIdWp(v: string) { this.setAttribute("wp-product-id", v); }

    static get observedAttributes() {
      return ["product-id", "wp-product-id"];
    }

    connectedCallback() {
      if (this.firstChild) return; // already mounted
      this.style.display = "contents";
      const productId = this.productId || undefined;
      const productIdWp = this.productIdWp || undefined;
      const props = { productId, productIdWp };
      this.#ctrl = new ReviewListController(this, props);
      this.#ctrl.mount();
    }

    disconnectedCallback() {
      this.#ctrl?.unmount();
      this.#ctrl = undefined;
    }

    attributeChangedCallback(
      name: string,
      _oldVal: string|null,
      _newVal: string|null
    ) {
      if (!this.isConnected || !this.#ctrl) return;
      if (name === "product-id") {
        this.#ctrl.updateProps({ productId: this.productId });
      } else if (name === "wp-product-id") {
        this.#ctrl.updateProps({ productIdWp: this.productIdWp });
      }
    }

    reload() { this.#ctrl?.reload(); }

  }

  customElements.define(TAG_NAME, AbReviewsListElement);

}
